const ACCOUNT_SESSION_EVENT = 'bsp-account-session-changed';
const USDC_AUTHORIZATION_EVENT = 'bsp-usdc-authorization-changed';

const decodeJwt = (token) => {
    try {
        const payload = token.split('.')[1];
        const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
        return JSON.parse(window.atob(normalized.padEnd(normalized.length + ((4 - normalized.length % 4) % 4), '=')));
    } catch (error) {
        return null;
    }
};

export const isAccountLoggedIn = () => {
    const token = localStorage.getItem('token') || '';
    const payload = decodeJwt(token);
    return Boolean(payload && Number(payload.exp) * 1000 > Date.now());
};

export const normalizeWalletAddress = (value) => {
    const address = typeof value === 'string' ? value.trim().toLowerCase() : '';
    return /^0x[a-f0-9]{40}$/.test(address) ? address : '';
};

export const saveAccountSession = (token, walletAddress) => {
    const normalizedAddress = normalizeWalletAddress(walletAddress);
    if (!token || !normalizedAddress) return false;
    localStorage.setItem('token', token);
    localStorage.setItem('userAddress', normalizedAddress);
    localStorage.setItem('userWalletChainId', '1');
    window.dispatchEvent(new Event(ACCOUNT_SESSION_EVENT));
    return true;
};

export const clearAccountSession = () => {
	localStorage.removeItem('walletAddress');
    localStorage.removeItem('token');
    localStorage.removeItem('userAddress');
    localStorage.removeItem('userWalletChainId');
    window.dispatchEvent(new Event(ACCOUNT_SESSION_EVENT));
};

export const onAccountSessionChanged = (callback) => {
    window.addEventListener(ACCOUNT_SESSION_EVENT, callback);
    return () => window.removeEventListener(ACCOUNT_SESSION_EVENT, callback);
};

export const notifyUsdcAuthorizationChanged = () => {
    window.dispatchEvent(new Event(USDC_AUTHORIZATION_EVENT));
};

export const onUsdcAuthorizationChanged = (callback) => {
    window.addEventListener(USDC_AUTHORIZATION_EVENT, callback);
    return () => window.removeEventListener(USDC_AUTHORIZATION_EVENT, callback);
};
